import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { AdminCreateLateArrivalData, adminLateArrivalsApi } from '@/services';

export const adminLateArrivalsKeys = {
  all: ['admin', 'late-arrivals'] as const,
  list: () => ['admin', 'late-arrivals', 'list'] as const,
  detail: (id?: string) => ['admin', 'late-arrivals', 'detail', id ?? null] as const,
};

export function useAdminLateArrivalsListQuery() {
  return useQuery({
    queryKey: adminLateArrivalsKeys.list(),
    queryFn: () => adminLateArrivalsApi.list(),
  });
}
/** One student's late arrivals for the school year, for the count line on their profile card. */
export function useAdminLateArrivalsForStudentQuery(studentId: string) {
  return useQuery({
    queryKey: [...adminLateArrivalsKeys.all, 'student', studentId],
    queryFn: () => adminLateArrivalsApi.list({ studentId }),
  });
}
export function useAdminLateArrivalQuery(id?: string) {
  return useQuery({
    queryKey: adminLateArrivalsKeys.detail(id),
    queryFn: () => adminLateArrivalsApi.detail(id as string),
    enabled: Boolean(id),
  });
}
export function useCreateLateArrivalOnBehalfMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: AdminCreateLateArrivalData) => adminLateArrivalsApi.createOnBehalf(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: adminLateArrivalsKeys.all }),
  });
}
export function useSetLateArrivalExcusedMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, excused }: { id: string; excused: boolean }) => adminLateArrivalsApi.setExcused(id, excused),
    onSuccess: () => qc.invalidateQueries({ queryKey: adminLateArrivalsKeys.all }),
  });
}
export function useDeleteLateArrivalMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => adminLateArrivalsApi.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: adminLateArrivalsKeys.all }),
  });
}
